import React from "react";
import classNames from "classnames";
import { useLocation } from '@gatsbyjs/reach-router';
import { routes } from "@nvs/gatsby-theme-leap-core/src/components/domains/confirmation/flow/confirmation-flow";

const HeroBackground = () => {
	const location = useLocation();
	const isConfirmationPage = location.pathname.includes(routes.confirmed)
	return (
		<div
			className={classNames(
				"h-[557px] w-full bg-hero-image bg-no-repeat bg-cover sm:bg-[length:100vw_557px] bg-center absolute z-[-1] print:hidden",
				{
					"mt-[95px] lg:mt-[159px]": !isConfirmationPage,
				}
			)}
		></div>
	);
};

export default HeroBackground;
